import React from 'react';
import Card from 'react-bootstrap/Card';

const SUPPORT_EMAIL = 'bjpineconego@gmail.com';

const DeleteAccount = () => {
  return (
    <div>
      <Card>
        <div className='padding2em'>
          <Card.Title>
            <h3>删除账号</h3>
          </Card.Title>
          <Card.Text>
            <div className='vPrivacy-content'>
              <p className='vPrivacy-intro'>
                本页面说明如何删除您在松果Go（Pinecone Go，开发者：Bluejay
                Inc）中的账号及相关数据。
              </p>
              <div className='vPrivacy-desc'>
                <dl>
                  <dt>方式一：在 App 内删除（推荐）</dt>
                  <dd>
                    打开松果Go App 并登录 → 进入「我的」页面 → 点击「账号设置」
                    →
                    选择「删除账号」，按提示确认。确认后删除请求会立即提交，无需再联系客服。
                  </dd>
                </dl>
                <dl>
                  <dt>方式二：通过邮件申请删除</dt>
                  <dd>
                    如果您已卸载 App 或无法登录，请从您注册时使用的邮箱发送邮件至{' '}
                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                    ，主题填写「删除账号申请」，并在正文注明您的注册邮箱（以及手机号，如有）。
                    我们会在收到申请后的 7
                    个工作日内核实身份并处理，处理结果会回复到该邮箱。
                  </dd>
                </dl>
                <dl>
                  <dt>会删除哪些数据</dt>
                  <dd>
                    账号信息（姓名、电子邮箱、手机号）、地址簿（寄件人与收件人姓名、电话、地址）、
                    推送通知标识符（设备推送 token），以及 App 使用记录与日志。
                    上述数据将在删除请求处理完成后的 30 天内从生产系统中移除，并在
                    90 天内从备份中清除。
                  </dd>
                </dl>
                <dl>
                  <dt>会保留哪些数据</dt>
                  <dd>
                    已完成的运单与交易记录自交易完成起保留 5
                    年，用于满足税务、财务及海关合规要求；
                    清关申报所需的收寄件信息按相关法律规定的最短期限保留。
                    保留期届满后，上述数据将被删除或永久匿名化。
                    保留期内这些记录不会用于营销，也不会用于恢复您已删除的账号。
                  </dd>
                </dl>
                <dl>
                  <dt>删除前请注意</dt>
                  <dd>
                    若您仍有在途包裹或未结清费用，请在这些订单完成后再申请删除账号。
                    账号删除后无法恢复，历史运单将无法在 App 内查询。
                  </dd>
                </dl>
                <dl>
                  <dt>有疑问？</dt>
                  <dd>
                    请联系{' '}
                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                    ，或查阅我们的<a href='/privacy'>隐私政策</a>。
                  </dd>
                </dl>
              </div>

              <h3 className='mt-5'>Delete your account</h3>
              <div className='vPrivacy-desc'>
                <dl>
                  <dt>Option 1 — In the app (recommended)</dt>
                  <dd>
                    Open the Pinecone Go app and sign in, go to the Me tab, tap
                    Account settings, then tap Delete account and confirm.
                  </dd>
                </dl>
                <dl>
                  <dt>Option 2 — By email</dt>
                  <dd>
                    If you have uninstalled the app or cannot sign in, email{' '}
                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> from
                    your registered address with the subject &ldquo;Account
                    deletion request&rdquo;. We verify and process requests
                    within 7 business days.
                  </dd>
                </dl>
                <dl>
                  <dt>What is deleted</dt>
                  <dd>
                    Account details (name, email address, phone number), saved
                    sender and recipient addresses, push notification tokens,
                    and app usage logs. These are removed from production
                    systems within 30 days and purged from backups within 90
                    days.
                  </dd>
                </dl>
                <dl>
                  <dt>What is retained</dt>
                  <dd>
                    Completed shipment and transaction records are kept for 5
                    years from the date of the transaction, and customs
                    declaration details for the minimum period required by law,
                    to meet tax, financial and customs obligations. After those
                    periods the data is deleted or permanently anonymized.
                    Retained records are never used for marketing or to restore
                    a deleted account.
                  </dd>
                </dl>
                <dl>
                  <dt>Before you delete</dt>
                  <dd>
                    If you have shipments in transit or unpaid balances, please
                    wait until those orders are complete. Account deletion
                    cannot be undone.
                  </dd>
                </dl>
              </div>
            </div>
          </Card.Text>
        </div>
      </Card>
    </div>
  );
};

export default DeleteAccount;
